// React & Vendor Libs
const { useState } = wp.element;
import useSWR from 'swr';

// NekoUI
import { useNekoTasks, NekoIcon, NekoButton, NekoModal, NekoTypo, NekoTheme } from 'neko-ui';

// Copytrack
import { apiUrl, jsonFetcher } from '../helpers';

// Styles
const containerStyle = {
  alignItems: 'center',
  maxWidth: 250,
  height: 60,
  borderRadius: 15,
  display: 'flex',
  padding: '2px 8px',
  transition: 'background-color 200ms linear'
};
const pStyle = {
  marginBottom: 2,
  marginTop: 0
}

const Status = (props) => {
  
  // Media
  const { mediaId } = props;
  const { data: status, mutate: mutateStatus } = useSWR(`${apiUrl}/status/${mediaId}`, jsonFetcher);

  // State & Error
  const [ isUploading, setIsUploading ] = useState(false);
  const [ error, setError ] = useState(null); 
  const [ displayError, setDisplayError ] = useState(false);

  const onClick = async () => {
    setIsUploading(true);
    const res = await fetch(`${apiUrl}/upload/${mediaId}`, { method: 'POST' });
    const newStatus = await res.json();
    mutateStatus(newStatus, false);
    setIsUploading(false);
    setError(newStatus.success ? null : newStatus.error);
  }

  const isInit = status !== undefined;
  const isCopytracked = !error && isInit && status.data;
  const isPending = !error && isInit && !isCopytracked;

  const gray = 'rgba(0, 0, 0, 0.10)';

	return (
    <div style={{ ...containerStyle }}>

      <NekoIcon icon={error ? 'alert' : isCopytracked ? 'check' : isPending ? 'upload' : 'cat'}
        style={{
          borderRadius: '100%',
          padding: 5,
          backgroundColor: error ? NekoTheme.red : isCopytracked ? NekoTheme.green : isPending ? NekoTheme.blue : gray 
        }}
        color="white" spinning={isUploading} width={32} height={32} />

      <div style={{ marginLeft: '10px' }}>

        {error && <>
          <NekoTypo p style={pStyle}><span>Error</span></NekoTypo>
          <NekoButton onClick={onClick} className='danger' disabled={isUploading}>Retry</NekoButton>
          <NekoButton onClick={() => setDisplayError(true)} className='danger' disabled={isUploading}>Show Error</NekoButton>
          <NekoModal isOpen={displayError} onRequestClose={() => setDisplayError(false)} title="Error" content={error} />
        </>}

        {isCopytracked && <>
          <NekoTypo p style={pStyle}>{status.data.id ? <span>Uploaded</span> : <span>Previously Uploaded</span>}</NekoTypo>
        </>}

        {isPending && <>
          <NekoTypo p style={pStyle}><span>Not Uploaded</span></NekoTypo>
          <NekoButton onClick={onClick} disabled={isUploading}>Upload Now</NekoButton>
        </>}

      </div>

    </div>
  );
}

export default Status;